var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('h3',[_vm._v("Oferty")])]),_c('BidderOfferList',{attrs:{"only-mine":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }